var map = {
	"./argos.jpg": 1041,
	"./cundinamarca_corazon_colombia.jpg": 4568,
	"./ecopetrol.png": 7782,
	"./gobernacion_antioquia.jpg": 8980,
	"./ingeominas.jpg": 5914,
	"./minenergia.png": 1059,
	"./minercol.jpg": 3799,
	"./oxy.jpg": 4935,
	"./upme.jpg": 9513
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7533;